import React from "react";
import { Pie } from "react-chartjs-2";

const BloodGroupPieChart = ({ bloodGroupStatistics }) => {
    const colors = [
        "#FF6384",  // A+
        "#36A2EB",  // A-
        "#FFCE56",  // B+
        "#4BC0C0",  // B-
        "#9966FF",  // AB+
        "#FF9F40",  // AB-
        "#FF6384",  // O+
        "#C9CBCF"   // O-
    ];

    const data = {
        labels: bloodGroupStatistics?.summary?.labels || [],
        datasets: [
            {
                data: bloodGroupStatistics?.summary?.data || [],
                borderWidth: 2,
                backgroundColor: colors,
                hoverBackgroundColor: colors.map(color => color + 'DD'),
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    font: { size: 12 },
                    usePointStyle: true,
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const { label, raw } = context;
                        const total = bloodGroupStatistics?.total || 0;
                        const percentage = total > 0 ? ((raw / total) * 100).toFixed(2) : 0;
                        return `${label}: ${raw} units (${percentage}%)`;
                    },
                },
            },
        },
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Pie data={data} options={options} />
        </div>
    );
};

export default BloodGroupPieChart;
